module.exports = __webpack_public_path__ + "static/media/brand_3.png";